import React from 'react';
import { C, S } from '../utils/styles';
import { fmt } from '../utils/formatters';

export default function TierCard({ tier, isOptimal, isSelected, onClick }) {
  const pos = tier.employeePerPeriodBenefit >= 0;
  return (
    <div data-testid={`tier-card-${tier.id}`} onClick={onClick} style={{
      ...S.card, padding: "14px 12px", cursor: "pointer", position: "relative",
      border: isSelected ? `2px solid ${C.accent}` : `1px solid ${C.border}`,
      background: isSelected ? C.accentBg : C.card,
      opacity: tier.isViable ? 1 : 0.5,
      transition: "all 0.15s",
    }}>
      {isOptimal && (
        <div style={{ position: "absolute", top: -1, right: -1, background: C.green, color: "#fff", fontSize: 8, fontWeight: 800, padding: "3px 8px", borderRadius: "0 12px 0 8px", letterSpacing: "0.06em", textTransform: "uppercase", ...S.mono }}>OPTIMAL</div>
      )}
      <div style={{ fontSize: 15, fontWeight: 800, color: C.text, marginBottom: 2 }}>{tier.label}</div>
      <div style={{ fontSize: 10, color: C.textLight, marginBottom: 10 }}>
        {fmt(tier.monthlyPremium)}/mo · {fmt(tier.monthlyClaim)} claim
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 6 }}>
        <div style={{ background: pos ? C.greenLight : C.redLight, borderRadius: 8, padding: "8px 6px", textAlign: "center" }}>
          <div style={{ fontSize: 8, color: C.textLight, textTransform: "uppercase", letterSpacing: "0.04em", marginBottom: 2 }}>Employee</div>
          <div style={{ fontSize: 15, fontWeight: 800, color: pos ? C.green : C.red, ...S.mono }}>{pos ? "+" : ""}{fmt(tier.employeePerPeriodBenefit)}</div>
        </div>
        <div style={{ background: C.blueLight, borderRadius: 8, padding: "8px 6px", textAlign: "center" }}>
          <div style={{ fontSize: 8, color: C.textLight, textTransform: "uppercase", letterSpacing: "0.04em", marginBottom: 2 }}>Employer</div>
          <div style={{ fontSize: 15, fontWeight: 800, color: C.blue, ...S.mono }}>{fmt(tier.employerPerPeriodFica)}</div>
        </div>
      </div>
      <div style={{ marginTop: 6, background: C.purpleLight, borderRadius: 6, padding: "4px", textAlign: "center" }}>
        <span style={{ fontSize: 9, color: C.purple, fontWeight: 700, ...S.mono }}>HC: {fmt(tier.spread)}/mo spread</span>
      </div>
      {!tier.isViable && <div style={{ marginTop: 6, fontSize: 9, color: C.red, textAlign: "center", fontWeight: 600 }}>⚠ {!tier.wageOk ? "Below min wage" : tier.isNegative ? "Negative impact" : "Not viable"}</div>}
    </div>
  );
}
